import {BaseUrlProvider} from "@/core/providers/base-url-provider";
import {AxiosInstanceProvider} from "@/core/providers/axios-instance-provider";

export class ApiClientProvider {
    public static provide<TClient>(type: (new (...args: any[]) => TClient)): TClient {
        return new type(BaseUrlProvider.getBaseUrl(), AxiosInstanceProvider.Get());
    }
}
